import { useContext } from 'react';
//
import { HTPhanQuyenTaiKhoan } from 'src/types/api-response';
import { AuthContext } from '../context/jwt/auth-context';
import { JWTContextType } from '../types';
// import { AuthContext } from '../context/auth0/auth-context';
// import { AuthContext } from '../context/amplify/auth-context';
// import { AuthContext } from '../context/firebase/auth-context';

// ----------------------------------------------------------------------

export const useAuthContext = (): JWTContextType & { isAdmin: boolean } & {isAuthenticated: boolean} => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }

  const isAdmin = context.user?.maVaiTros?.some((vaitro: HTPhanQuyenTaiKhoan) => vaitro.maVaiTro  === 'nft_admin' || vaitro.maVaiTro  === 'nft_garden') ?? false;
  const isAuthenticated = context.authenticated;
  return { ...context, isAdmin, isAuthenticated};
}; 

